export const ButtonPrint = {
  transclude: true,

  bindings: {
    uri: '@',
    tooltip: '<',
  },

  template: `
    <a class="btn btn-link px-1"
      ng-href="{{ $ctrl.uri }}"
      ng-show="$ctrl.uri"
      data-toggle="tooltip-print">
      <i class="fa fa-lg icon-print mr-0"></i>
      <ng-transclude>Print</ng-transclude>
    </a>`,

  controller() {
    'ngInject';

    return {
      $onChanges({ tooltip }) {
        if (tooltip && tooltip.currentValue) {
          $('[data-toggle="tooltip-print"]').tooltip('dispose');
          $('[data-toggle="tooltip-print"]').tooltip({
            placement: 'left',
            title: tooltip.currentValue,
          });
        }
      },

      $onDestroy() {
        $('[data-toggle="tooltip-print"]').tooltip('hide');
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Button/ButtonPrint.js